import { SYSTEM_MSG_RECEIVED, USER_MSGS_RECEIVED, USER_MSGS_UNREAD, USER_MSG_CREATED, USER_MSG_UPDATED, CHANGE_LOG_RECEIVED } from './types'
import { isEmpty } from 'globals/utils'
export default function messages(state = {}, action = {}){
  let user = null
  switch (action.type) {
    case SYSTEM_MSG_RECEIVED:
      return {
        ...state,
        system: action.data
      }
    case CHANGE_LOG_RECEIVED:
      return {
        ...state,
        changelog: action.data
      }
    case USER_MSGS_RECEIVED:
      return {
        ...state,
        user: action.data
      }
    case USER_MSGS_UNREAD:
      return {
        ...state,
        unread: action.data
      }
    case USER_MSG_CREATED:
      user = state.user
      if (isEmpty(user)) { user = []}
      user.push(action.data)
      return {
        ...state,
        user
      }
    case USER_MSG_UPDATED:
      user = state.user.map((item, index) => {
        // Find the item with the matching id
        if(item.id === action.data.id) {
          return {
            ...item,  // copy the existing item
            tag: action.data.tag,
            opened: action.data.opened
          }
        }
        return item 
      }) 
      return {
        ...state,
        user
      }
    default:
      return state;
  }
}
